import React from 'react';
import styles from './InfoTab.module.scss';
import { isEmpty } from 'lodash';

const ApplicantsTab = ({
  active,
  text,
  handleOnClick,
  icon,
  number,
  shadowed = true,
  tabWidth = '',
  inactiveColor = '',
  fs,
}) => {
  const tabClass = active ? 'active-tab' : 'inactive-tab';
  const classFont = active ? 'active-circle' : 'inactive-circle';
  const hr = active ? 'underline' : '';
  const tabImage = active ? 'activeTabImage' : '';
  const shadow = active && shadowed ? 'shadowed' : '';
  return (
    <div
      className={`${styles['applicant-tab']} ${styles[tabClass]} ${styles[shadow]} ${styles[hr]}`}
      onClick={handleOnClick}
      style={{ justifyContent: icon ? '' : 'center', width: tabWidth }}
    >
      {icon && (
        <img
          src={icon}
          alt="icon"
          className={`${styles['tabImage']} ${styles[tabImage]}`}
        />
      )}
      <h4 style={{ fontSize: fs, color: active ? '' : inactiveColor }}>
        {text}
      </h4>
      {number >= 0 && <p className={`${styles[classFont]}`}>{number}</p>}
    </div>
  );
};

export default ApplicantsTab;
